module.exports = __webpack_public_path__ + "img/8009.6925a5ad.gif";